module.exports = __webpack_public_path__ + "static/media/download.8b494d2a.svg";